/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:01:15
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-06 11:45:34
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/ResponsiveText/index.tsx
 */
import React from 'react';

import _Text from 'src/components/Modules/ResponsiveText';

import ContentGroupHOC from '../HOC';
import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';
import { compose } from 'redux';

const ResponsiveText = (props) => {
  const {
    staticData,
    handleOnStaticsChange,
    specificError,
    linkSet,
    extraProps,
    draggableId,
  } = props || {};
  const { breakpoint } = extraProps || {};
  const h1TagUuid = (extraProps || {}).h1TagUuid;
  const disableTagCheckbox = h1TagUuid ? draggableId !== h1TagUuid : false;

  return (
    <_Text
      disableTagCheckbox={disableTagCheckbox}
      linkSet={linkSet}
      staticData={staticData}
      onStaticChange={handleOnStaticsChange}
      specificError={specificError}
      breakpoint={breakpoint}
    />
  );
};
export default compose(DataHOC, ContentGroupHOC)(ResponsiveText);
